export type NativeShareResult = 'shared' | 'cancelled' | 'unsupported' | 'failed';

export function canShareNatively(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

/**
 * Share a rendered card image through the OS share sheet (mobile) as
 * "url\ntext" + the image file; falls back to a plain text/url share when the
 * system can't share files.
 */
export async function shareImageNatively(
  blob: Blob | null,
  { fileName, text, url }: { fileName: string; text: string; url: string },
): Promise<NativeShareResult> {
  if (!canShareNatively()) return 'unsupported';

  const file = blob ? new File([blob], fileName, { type: 'image/png' }) : null;

  try {
    if (file && navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], text: `${url}\n${text}` });
    } else {
      await navigator.share({ text, url });
    }
    return 'shared';
  } catch (error) {
    return shareErrorResult(error);
  }
}

function shareErrorResult(error: unknown): NativeShareResult {
  return (error as Error)?.name === 'AbortError' ? 'cancelled' : 'failed';
}
